import { useHistory } from "react-router-dom";
import {
  FitnessCenter,
  Person,
  Handshake,
  LocationOn,
  Home,
} from "@mui/icons-material";
import {
  BottomNavigation,
  Slide,
  BottomNavigationAction as Tab,
  Typography,
} from "@mui/material";
import { THEME } from "../../styles/theme";
import FlashMessage from "../flash-message";

const BOTTOM_TAB_OPTIONS = [
  {
    label: "Home",
    value: "/",
    icon: <Home />,
  },
  {
    label: "Parceiros",
    value: "/associations",
    icon: <Handshake />,
  },
  {
    label: "Treinos",
    value: "/training",
    icon: <FitnessCenter />,
  },
  {
    label: "Unidades",
    value: "/units",
    icon: <LocationOn />,
  },
  {
    label: "Perfil",
    value: "/profile",
    icon: <Person />,
  },
];

const BottomTab = (props: any) => {
  const history = useHistory();
  const [_, firstPath] = props.location.pathname.split("/");
  const value = `/${firstPath}`;

  return (
    <>
      <FlashMessage />
      <Slide in direction="up" timeout={500}>
        <BottomNavigation
          showLabels
          value={value}
          onChange={(_, newValue) => {
            history.push(newValue);
          }}
          sx={{
            marginTop: "auto",
            height: "4rem",
            borderRadius: "1.5rem 1.5rem 0 0",
            background: THEME.palette.background.default,
          }}
        >
          {BOTTOM_TAB_OPTIONS.map((tab) => (
            <Tab
              defaultChecked
              key={tab.value}
              label={<Typography variant="caption">{tab.label}</Typography>}
              value={tab.value}
              icon={tab.icon}
              sx={{ borderRadius: "1.5rem" }}
            />
          ))}
        </BottomNavigation>
      </Slide>
    </>
  );
};

export default BottomTab;
